import { Text as NextText } from '@nextui-org/react';
import styled from 'styled-components';

const Text = styled(NextText).attrs(({ css }) => ({
  css: {
    ...(css ?? {}),
    margin: 0,
    letterSpacing: 'normal',
  },
}))``;

/*const Text = styled.div`
  margin: 0;
  letter-spacing: normal;
`;*/

export default Text;
